import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, ReferenceArea } from "recharts";
import { InfoHint } from "./InfoHint";
import { Gauge } from "@phosphor-icons/react";

const levelCfg = {
  low: { c: "#8899a6", t: "Недогруз" },
  optimal: { c: "#00e676", t: "Оптимум" },
  elevated: { c: "#ffea00", t: "Повышенный риск" },
  danger: { c: "#ff3b30", t: "Опасная зона" },
};

export default function AcwrCard({ acwr }) {
  if (!acwr) return null;
  const cfg = levelCfg[acwr.level];
  const pos = Math.min(100, Math.max(0, ((acwr.ratio - 0.4) / 1.4) * 100));
  return (
    <div className="glass-card p-5" data-testid="acwr-card">
      <div className="flex items-center gap-2 mb-1 flex-wrap">
        <Gauge size={18} weight="fill" style={{ color: cfg.c }} />
        <h3 className="text-sm font-semibold">Риск перетренированности (ACWR) · <span style={{ color: cfg.c }}>{cfg.t}</span><InfoHint text="ACWR — отношение острой нагрузки (за 7 дней) к хронической (за 28 дней). Зона 0.8–1.3 — оптимально; выше 1.5 — резкий скачок нагрузки и повышенный риск травм и перетренированности." /></h3>
        <span className="ml-auto num font-bold text-lg" style={{ color: cfg.c }} data-testid="acwr-ratio">{acwr.ratio}</span>
      </div>
      <p className="text-xs text-muted-foreground mb-3">
        Острая нагрузка (7 дн: {acwr.acute}) ÷ хроническая (28 дн: {acwr.chronic}). {acwr.verdict}
      </p>
      <div className="relative h-3 rounded-full overflow-hidden flex mb-1" data-testid="acwr-scale">
        <div className="h-full" style={{ width: "28.6%", background: "#8899a6", opacity: 0.5 }} />
        <div className="h-full" style={{ width: "35.7%", background: "#00e676", opacity: 0.6 }} />
        <div className="h-full" style={{ width: "14.3%", background: "#ffea00", opacity: 0.6 }} />
        <div className="h-full flex-1" style={{ background: "#ff3b30", opacity: 0.6 }} />
        <div className="absolute top-[-2px] h-4 w-1 rounded bg-white" style={{ left: `${pos}%` }} />
      </div>
      <div className="flex justify-between text-[9px] text-muted-foreground num mb-3">
        <span>0.4</span><span>0.8</span><span>1.3</span><span>1.5</span><span>1.8+</span>
      </div>
      <ResponsiveContainer width="100%" height={120}>
        <LineChart data={acwr.series}>
          <XAxis dataKey="date" tickFormatter={(d) => `${d.slice(8, 10)}.${d.slice(5, 7)}`} stroke="hsl(220 10% 40%)" fontSize={10} tickLine={false} axisLine={false} />
          <YAxis domain={[0.4, "auto"]} stroke="hsl(220 10% 40%)" fontSize={10} tickLine={false} axisLine={false} width={28} />
          <Tooltip contentStyle={{ background: "hsl(220 10% 12%)", border: "1px solid hsl(220 10% 22%)", borderRadius: 8, fontSize: 12 }} />
          <ReferenceArea y1={0.8} y2={1.3} fill="#00e676" fillOpacity={0.08} />
          <Line type="monotone" dataKey="ratio" name="ACWR" stroke="#0084ff" strokeWidth={2} dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
